const getUserIdFormToken = () => {
    try {
        const token = sessionStorage.getItem('assume_token') || localStorage.getItem('token');
        const[,tokenData,] = token.split('.');
        const parsedData = JSON.parse(atob(tokenData));

        return +parsedData.sub;
    } catch (_) {
        return null;
    }
};

export const tenDLCBanner = () => {
    const userId = getUserIdFormToken();
    if (!userId) return;

    const flagName = `${userId}_isShowTenDLCBanner`;
    const dateName = `${userId}_tenDLCBannerLastDate`;

    // Disabled TenDLCBanner
    if (window.localStorage.getItem(flagName) === 'false') {
        clearTimeout(window.globalTenDLCBannerTimer);
        window.globalTenDLCBannerTimer = null;
    }

    if (window.TenDLCBanner && window.localStorage.getItem(flagName) === 'true' && window.localStorage.getItem(dateName)) {
        if (window.TenDLCBanner) {
            if (window.localStorage.getItem(dateName)) {
                const tenDLCBannerLastDate = new Date(window.localStorage.getItem(dateName)).toISOString();

                const momentTenDLCBannerLastDate = moment(tenDLCBannerLastDate);
                const currentTime = moment(new Date().toISOString());

                clearTimeout(window.globalTenDLCBannerTimer);
                window.globalTenDLCBannerTimer = null;
                const minCount = 480;

                if (currentTime.diff(momentTenDLCBannerLastDate, 'minutes') > minCount) {
                    window.TenDLCBanner.showModal();
                } else {
                    const timer = (minCount - currentTime.diff(momentTenDLCBannerLastDate, 'minutes')) * 1000 * 60;

                    window.globalTenDLCBannerTimer = setTimeout(() => {
                        window.TenDLCBanner.showModal();
                    }, timer);
                }
            } else {
                window.TenDLCBanner.showModal();
            }
        }
    }
};
